import { DefaultButton, IContextualMenuProps, PrimaryButton, useTheme } from "@fluentui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faFloppyDisk, faRotateLeft, faUpload } from "@fortawesome/free-solid-svg-icons";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import React, { useContext } from "react";
import { DraftStatus, shiftsContext } from "../../providers/shifts";
import Swal from "sweetalert2";
import { toast } from "../../helpers/notifications";
import {
    createUnsavedChangesPromptOptions,
    shouldShowUnsavedChangesNavigationPrompt
} from "../../helpers/drafts/globalDraftAvailability";

const DraftControl = () => {
    const { draftStatus, isGlobalDraftEnabled, isSavingDraft, deleteDraft, saveDraft, loadDraft, undoShiftMove, validateAndPublishShifts: validateAndPublishShifts, reloadShifts,validateAllShifts, checkShiftUnsavedChanges } = useContext(shiftsContext)
    const theme = useTheme();

    const handleReloadShifts = async () => {
        if (isSavingDraft) return;

        const hasUnsavedChanges = checkShiftUnsavedChanges();
        if (!shouldShowUnsavedChangesNavigationPrompt({
            isGlobalDraftEnabled,
            hasUnsavedChanges,
            draftStatus: DraftStatus[draftStatus],
        })) {
            await reloadShifts();
            return;
        }

        const promptResult = await Swal.fire(createUnsavedChangesPromptOptions(
            theme.palette.themePrimary,
            theme.palette.tealLight
        ));

        if (promptResult.dismiss === Swal.DismissReason.cancel) {
            await reloadShifts({ forceGlobalDraftPrompt: true });
            return;
        }

        if (promptResult.isDismissed && !promptResult.isDenied && !promptResult.isConfirmed) {
            return;
        }

        if (promptResult.isConfirmed) {
            const saved = await saveDraft();
            if (!saved) {
                toast('error', 'Draft could not be saved. Your changes are still on the roster. Try again or use "No" to refresh without saving.');
                return;
            }

            await reloadShifts({
                forceGlobalDraftPrompt: true,
                savedGlobalDraft: {
                    draftId: saved.id,
                    draftVersion: saved.createdOn,
                },
            });
        }
    }

    const renderDraftButton = () => {
        const menuProps: IContextualMenuProps = {
            items: [
                {
                    key: 'saveDraft',
                    text: 'Save Draft',
                    onClick: saveDraft,
                    disabled: isSavingDraft || (draftStatus !== DraftStatus.empty && draftStatus !== DraftStatus.edited)
                },
                {
                    key: 'loadDraft',
                    text: 'Load Draft',
                    onClick: () => loadDraft(),
                    disabled: isSavingDraft || (!isGlobalDraftEnabled && draftStatus === DraftStatus.empty)
                },
                {
                    key: 'discardDraft',
                    text: 'Discard Draft',
                    onClick: deleteDraft,
                    disabled: isSavingDraft || draftStatus === DraftStatus.empty
                }
            ]
        }

        return <DefaultButton menuProps={menuProps}>Drafts</DefaultButton>
    }

    const renderValidateButton = () => {
        const menuProps: IContextualMenuProps = {
            items: [
                {
                    key: 'validate',
                    text: 'Validate',
                    onClick: validateAllShifts
                },
                {
                    key: 'publish',
                    text: 'Publish',
                    onClick: validateAndPublishShifts
                }
            ]
        }

        return <PrimaryButton menuProps={menuProps}>Validate</PrimaryButton>
    }
    return (
        <div style={{ display: "inline-flex", gap: '5px',alignItems:'center' }}>
            {/*<DefaultButton onClick={calculateCost}>*/}
            {/*    Estimate Cost*/}
            {/*</DefaultButton>*/}
            {renderDraftButton()}
            {renderValidateButton()}
            <DefaultButton className="rb-small-button" onClick={undoShiftMove} title="Undo">
                <FontAwesomeIcon icon={["fas", "rotate-left" as IconName]} />
            </DefaultButton>
            <DefaultButton className="rb-small-button" onClick={handleReloadShifts} disabled={isSavingDraft} title="Reload">
                <FontAwesomeIcon icon={["fas", "arrows-rotate" as IconName]} />
            </DefaultButton>
        </div>

    )
}

export { DraftControl }
